import API from "../../../../../global/api";
import _ from "lodash";


export const requestAddLevelThree = () => {
    return {
        type: "REQUEST_ADD_LEVELTHREE",
    };
};
export const successAddLevelThree = (data) => {
    return {
        type: "SUCCESS_ADD_LEVELTHREE",
        payload: data,
    };
};
export const errorAddLevelThree = () => {
    return {
        type: "ERROR_ADD_LEVELTHREE",
    };
};
export const AddLevelThreeApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddLevelThree());
        API.post(`/levelThree/add_levelThree`, data).then((res) => {
            dispatch(successAddLevelThree(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddLevelThree());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetLevelThree = () => {
    return {
        type: "REQUEST_GET_LEVELTHREE",
    };
};
export const successGetLevelThree = (data) => {
    return {
        type: "SUCCESS_GET_LEVELTHREE",
        payload: data,
    };
};
export const errorGetLevelThree = () => {
    return {
        type: "ERROR_GET_LEVELTHREE",
    };
};
export const GetLevelThreeApi = () => {
    return (dispatch) => {
        dispatch(requestGetLevelThree());
        API.get(`/levelThree`).then((res) => {
            let getData = res.data;
            dispatch(successGetLevelThree(getData));
        }).catch((error) => {
            dispatch(errorGetLevelThree());
        })
    };
};


export const requestGetLevelThreeWithLevelTwoID = () => {
    return {
        type: "REQUEST_GET_LEVELTHREE_WITH_LEVELTWO_ID",
    };
};
export const successGetLevelThreeWithLevelTwoID = (data) => {
    return {
        type: "SUCCESS_GET_LEVELTHREE_WITH_LEVELTWO_ID",
        payload: data,
    };
};
export const errorGetLevelThreeWithLevelTwoID = () => {
    return {
        type: "ERROR_GET_LEVELTHREE_WITH_LEVELTWO_ID",
    };
};
export const GetLevelThreeWithLevelTwoIDApi = (levelTwoId) => {
    return (dispatch) => {
        dispatch(requestGetLevelThreeWithLevelTwoID());
        API.get(`/levelThree/get_by_levelTwo/${levelTwoId}`).then((res) => {
            let getData = res.data;
            dispatch(successGetLevelThreeWithLevelTwoID(getData));
        }).catch((error) => {
            dispatch(errorGetLevelThreeWithLevelTwoID());
        })
    };
};


export const requestUploadLevelThreeFile = () => {
    return {
        type: "REQUEST_UPLOAD_LEVELFTHREE_FILE",
    };
};
export const successUploadLevelThreeFile = (data) => {
    return {
        type: "SUCCESS_UPLOAD_LEVELFTHREE_FILE",
        payload: data,
    };
};
export const errorUploadLevelThreeFile = () => {
    return {
        type: "ERROR_UPLOAD_LEVELTHREE_FILE",
    };
};
export const UploadLevelThreeFileApi = (data, handleVisible, handleDangerVisible) => {
    const formData = new FormData();
    formData.append("levelOneId", `${data.levelOneId}`);
    formData.append("levelTwoId", `${data.levelTwoId}`);
    formData.append("file", _.get(data, 'file'));

    return (dispatch) => {
        dispatch(requestUploadLevelThreeFile());
        API.post(`/levelThree/upload_levelThree`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            dispatch(successUploadLevelThreeFile(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorUploadLevelThreeFile());
            handleDangerVisible(error.response.data.message);
        });
    };
};


export const DeleteRequestLevelThree = () => {
    return {
        type: "DELETE_REQUEST_LEVEL_THREE",
    };
};
export const DeleteSuccessLevelThree = (level_id) => {
    return {
        type: "DELETE_SUCCESS_LEVEL_THREE",
        level_id: level_id,
    };
};
export const DeleteErrorLevelThree = () => {
    return {
        type: "DELETE_ERROR_LEVEL_THREE",
    };
};
export const DeleteLevelThreeApi = (levelThreeId) => {
    return dispatch => {
        dispatch(DeleteRequestLevelThree());
        API.delete(`/levelThree/delete_levelThree/${levelThreeId}`).then(res => {
            dispatch(GetLevelThreeApi());
            dispatch(DeleteSuccessLevelThree(levelThreeId))
        }).catch((error) =>
            dispatch(DeleteErrorLevelThree()));
    }
};


export const UpdateRequestLevelThree = () => {
    return {
        type: "UPDATE_REQUEST_LEVEL_THREE",
    };
};
export const UpdateSuccessLevelThree = (level_id) => {
    return {
        type: "UPDATE_SUCCESS_LEVEL_THREE",
        level_id: level_id,
    };
};
export const UpdateErrorLevelThree = () => {
    return {
        type: "UPDATE_ERROR_LEVEL_THREE",
    };
};
export const UpdateLevelThreeApi = (data, oldData) => {
    return dispatch => {
        dispatch(UpdateRequestLevelThree());
        API.put(`/levelThree/update_levelThree/${oldData._id}`, {
            levelThreeName: _.toUpper(data.levelThreeName),
        }, {
        }).then(res => {
            dispatch(GetLevelThreeApi());
            dispatch(UpdateSuccessLevelThree([data]))
        }).catch((error) => {
            dispatch(UpdateErrorLevelThree());
        })
    }
};